import { render, staticRenderFns } from "./AtendimentoEnfermagem.vue?vue&type=template&id=f18eccde&scoped=true&"
import script from "./AtendimentoEnfermagem.vue?vue&type=script&lang=js&"
export * from "./AtendimentoEnfermagem.vue?vue&type=script&lang=js&"
import style0 from "./AtendimentoEnfermagem.vue?vue&type=style&index=0&id=f18eccde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18eccde",
  null
  
)

export default component.exports